export class TasksFakeDb {
  public static tasks = [
    {
      id: "45cghnnd4783ncnv6d68s3crf",
      uuid: "45cghnnd4783ncnv6d68s3crf",
      profile_id: "1234-1234-1324-1324",
      datetime: new Date(),
      duration: 30,
      address: "Rua Quinta dos Morgados YY, Barreiro e Lavradio, Portugal",
      location: "Bedroom",
      notes: [
        {
          author_id: "5edebhh5dfis8",
          author: "Daria D",
          datetime: new Date(),
          note: "",
        },
      ],
      supervisor: false,
      client: {
        profile_uuid: "345456l",
        profile_name: "Selvador Kris",
        status: 0,
      },
      supplier: {
        profile_uuid: "98746563f",
        profile_name: "Jack Allon",
        status: 2,
      },
      resource: {
        profile_uuid: "bdfg42nd563",
        profile_name: "Trevino Marvel",
        status: 1,
      },
      timesheet: {
        signoff: {
          datetime: "2020-05-15T05:33:32Z",
          location: null,
          signature: "aURL",
          userId: "72725330-e0ac-41e0-a504-d29b8c641d9d",
        },
        signon: {
          datetime: "2020-05-15T05:33:32Z",
          location: null,
          signature: "aURL",
          userId: "72725330-e0ac-41e0-a504-d29b8c641d9d",
        },
      },
    },
    {
      id: "96433426gd47238gdxs5",
      uuid: "96433426gd47238gdxs5",
      profile_id: "1234-1234-1324-1324",
      datetime: new Date(),
      duration: 30,
      address: "Rua Quinta dos Morgados YY, Barreiro e Lavradio, Portugal",
      location: "Bedroom",
      notes: [
        {
          author_id: "5edebhh5dfis8",
          author: "Daria D",
          datetime: new Date(),
          note: "",
        },
      ],
      supervisor: false,
      client: {
        profile_uuid: "345456l",
        profile_name: "Selvador Kris",
        status: 0,
      },
      supplier: {
        profile_uuid: "98746563f",
        profile_name: "Jack Allon",
        status: 2,
      },
      resource: {
        profile_uuid: "bdfg42nd563",
        profile_name: "Trevino Marvel",
        status: 1,
      },
      timesheet: {
        signoff: {
          datetime: "",
          location: null,
          signature: "",
          userId: "",
        },
        signon: {
          datetime: "2020-05-15T05:33:32Z",
          location: null,
          signature: "aURL",
          userId: "72725330-e0ac-41e0-a504-d29b8c641d9d",
        },
      },
    },
  ];

  public static shifts = [
    {
      uuid: "c0a314f7-4128-4edf-b4d1-623435b04388",
      shift_number: "",
      account_uuid: "9e210492-39da-4c7a-97bf-00488a66c1bd",
      datetime: "2022-08-26T11:00:00Z",
      duration: 90,
      notes: [],
      client_uuid: "9e210492-39da-4c7a-97bf-00488a66c1bd",
      tasks: [
        {
          uuid: "4e0d9c60-dd69-4f78-a54a-c9f1dc1c71cd",
          shift_uuid: "c0a314f7-4128-4edf-b4d1-623435b04388",
          notes: [
            {
              author_id: "818bd5e6-ec6c-4728-ad80-d8af8b91bb99",
              author: "",
              datetime: "2022-08-25T03:54:49.804Z",
              note: "Here is a note about the task",
            },
          ],
          task_items: [],
          supervisor: false,
          supplier: {
            uuid: "9e210492-39da-4c7a-97bf-00488a66c1bd",
            name: "CERIANI, JACK",
            email: "",
          },
          resource: {
            uuid: "72bc6204-f995-4d6f-8c5b-8bd70c9b0930",
            release_status: 2,
            name: "test test",
            email: "test-user-7@test.com",
          },
          timesheet: {
            uuid: "c0d2a014-f7bc-4bcf-8506-d48b273159c4",
            signon: {
              signature:
                '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 390 240" width="130" height="80"><path d="M 97.000,107.000 C 126.591,94.238 127.000,96.000 157.000,85.000" stroke-width="6.275" stroke="black" fill="none" stroke-linecap="round"></path><path d="M 157.000,85.000 C 169.378,78.270 166.091,82.238 176.000,83.000" stroke-width="6.463" stroke="black" fill="none" stroke-linecap="round"></path><path d="M 176.000,83.000 C 189.204,95.740 186.878,90.770 192.000,110.000" stroke-width="6.740" stroke="black" fill="none" stroke-linecap="round"></path><path d="M 192.000,110.000 C 192.812,124.243 194.204,121.240 186.000,134.000" stroke-width="6.220" stroke="black" fill="none" stroke-linecap="round"></path><path d="M 186.000,134.000 C 171.599,149.958 174.312,150.743 155.000,163.000" stroke-width="5.207" stroke="black" fill="none" stroke-linecap="round"></path><path d="M 155.000,163.000 C 143.093,173.521 143.599,171.958 130.000,178.000" stroke-width="5.560" stroke="black" fill="none" stroke-linecap="round"></path><path d="M 130.000,178.000 C 121.865,179.329 124.093,180.021 117.000,176.000" stroke-width="6.588" stroke="black" fill="none" stroke-linecap="round"></path><path d="M 117.000,176.000 C 108.411,169.265 112.365,172.829 111.000,165.000" stroke-width="7.703" stroke="black" fill="none" stroke-linecap="round"></path><path d="M 111.000,165.000 C 121.485,154.105 116.911,155.265 134.000,148.000" stroke-width="6.203" stroke="black" fill="none" stroke-linecap="round"></path><path d="M 134.000,148.000 C 144.032,141.843 141.985,144.105 152.000,145.000" stroke-width="6.495" stroke="black" fill="none" stroke-linecap="round"></path><path d="M 152.000,145.000 C 168.971,157.962 170.532,152.343 187.000,169.000" stroke-width="5.264" stroke="black" fill="none" stroke-linecap="round"></path><path d="M 187.000,169.000 C 193.754,173.551 193.471,172.962 201.000,175.000" stroke-width="6.310" stroke="black" fill="none" stroke-linecap="round"></path></svg>',
              datetime: "2022-08-25T19:53:26Z",
              duration: 90,
              geolocation: {
                type: "point",
                coordinates: [100, 100],
              },
              userId: "72bc6204-f995-4d6f-8c5b-8bd70c9b0930",
              role: 0,
            },
            signoff: {
              datetime: "0001-01-01T00:00:00Z",
              geolocation: {
                type: "",
                coordinates: null,
              },
              role: 0,
            },
            breaks: [],
          },
          credentials: [
            {
              category: "Security License",
              accreditation: "NSW Security",
              class: ["Crowd Control Agent"],
            },
          ],
          datetime: "0001-01-01T00:00:00Z",
          duration: 0,
          assessments: [],
          role: {
            name: "",
            item_code: "",
            description: "",
            rates: null,
            credentials: null,
          },
          compliance_issues: null,
          form_data: [],
        },
      ],
      admins: [],
      venue: {
        uuid: "3252a133-b38a-45de-b219-a305f8101f19",
        name: "Tremblay - Pacocha",
        contract_start_date: "",
        contract_term: "",
        contract_review_date: "",
        executing_parties: "",
        address: {
          street_location: "862 Joan Greens,  Sydney, NSW, 2000",
          geo_location: {
            type: "point",
            coordinates: [66.611, 36.2325],
          },
          "google-place-id": "87224605-b262-468d-b830-4e04371f5b56",
          "google-call":
            "https://maps.google.com/13b66357-172d-4c1e-8652-cd8e20efa5cb",
          timezone: "Australia/Sydney",
        },
        stations: [
          {
            name: "Main Entrance",
          },
          {
            name: "Side Entrance",
          },
          {
            name: "Rear Entrance",
          },
        ],
        type: "Public",
        licence_number: "95725949",
        licence_name: "Infrastructure",
        logo: "",
        roles: [],
        resource_rates: null,
        documents: [],
        comment: "",
        accreditation_requirements: [],
        managers: null,
      },
      release_history: [
        {
          uuid: "b70d3ac4-3bfe-48f6-8702-3baa180845d6",
          release_date: "2022-08-25T03:55:26.753Z",
          released_by_member: {
            uuid: "818bd5e6-ec6c-4728-ad80-d8af8b91bb99",
            email: "test-user-1@test.com",
            phone: "+61 2 2323 2342",
          },
          release_status: 1,
          notifications: [],
          system_note: "Shift released to client",
        },
        {
          uuid: "9d24f7b2-de71-47c2-b57d-497327e231c7",
          release_date: "2022-08-25T03:56:46.849Z",
          released_by_member: {
            uuid: "818bd5e6-ec6c-4728-ad80-d8af8b91bb99",
            email: "test-user-1@test.com",
            phone: "+61 2 2323 2342",
          },
          release_status: 2,
          notifications: [
            {
              uuid: "a4b8aff9-565f-4733-ba5f-2aa884183c68",
              notification_date: "2022-08-25T03:56:47.185Z",
              notification_to: {
                uuid: "9e210492-39da-4c7a-97bf-00488a66c1bd",
                name: "CERIANI, JACK",
                email: "",
              },
              carrier: "email",
            },
          ],
          system_note: "Shift released to suppliers",
        },
        {
          uuid: "f3a9eacd-c2b6-4b36-8c4e-59e4622b6819",
          release_date: "2022-08-25T03:57:26.634Z",
          released_by_member: {
            uuid: "818bd5e6-ec6c-4728-ad80-d8af8b91bb99",
            email: "test-user-1@test.com",
            phone: "+61 2 2323 2342",
          },
          release_status: 3,
          notifications: [],
          system_note: "Shift released to resources",
        },
      ],
      release_status: 3,
      form_data: null,
    },
  ];
}
